/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AutomaticTriageConfig,
    AutomaticTriageConfigFromJSON,
    AutomaticTriageConfigFromJSONTyped,
    AutomaticTriageConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface TriageConfig
 */
export interface TriageConfig {
    /**
     * 
     * @type {boolean}
     * @memberof TriageConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {AutomaticTriageConfig}
     * @memberof TriageConfig
     */
    automatic?: AutomaticTriageConfig;
}

export function TriageConfigFromJSON(json: any): TriageConfig {
    return TriageConfigFromJSONTyped(json, false);
}

export function TriageConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriageConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'automatic': !exists(json, 'automatic') ? undefined : AutomaticTriageConfigFromJSON(json['automatic']),
    };
}

export function TriageConfigToJSON(value?: TriageConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'automatic': AutomaticTriageConfigToJSON(value.automatic),
    };
}

